import { Component, OnInit } from '@angular/core';
import { DocumentoService } from 'src/app/_services/documento.service';
import { Router } from '@angular/router';
import { User } from 'src/app/_models';

@Component({
  selector: 'app-tipoDocumento',
  templateUrl: './tipoDocumento.component.html',
  styleUrls: ['./tipoDocumento.component.css'],
})

export class TipoDocumentoComponent implements OnInit {
  step = 10;
  currentUser: User;

  constructor(private documentoService: DocumentoService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  setStep(index: number) {
    this.step = index;
  }

  getFile() {
    this.documentoService.obterDocumentoDuvida().subscribe(respData => {
      this.downloadFile(respData);
    }, error => {
      console.log(error);
    });
  }

  downloadFile(data: any) {
    const blob = new Blob([data]);
    const a = document.createElement('a');
    const fileURL = URL.createObjectURL(blob);
    a.href = fileURL;
    a.download = 'Imagem dúvida.pdf';
    window.document.body.appendChild(a);
    a.click();
    window.document.body.removeChild(a);
    URL.revokeObjectURL(fileURL);
  }

  redirecionarProtocoloFiscal() {
    this.router.navigate(['/protocolo-fiscal']);
  }
}
